module.exports = __webpack_public_path__ + "static/media/teacher17.b493d32e.png";